import { Check, ChevronDown } from 'lucide-react'
import { Menu } from '../common'
import styles from './DashboardFilterControls.module.css'

// A page filter drawn like the range picker it sits beside: an icon, the
// current choice and a chevron, so a toolbar of range, compare and the
// page's own filters reads as one row of controls. A choice other than the
// first (the "all" default) outlines the trigger, as picked states do.
export function ToolbarMenu({ label, icon: Icon, value, items, onChange, align = 'start', disabled = false }) {
  const current = items.find((item) => item.value === value) || items[0]
  return (
    <Menu
      align={align}
      selectionMode="single"
      triggerLabel={label}
      trigger={(
        <button
          type="button"
          className={styles.trigger}
          aria-label={`${label}: ${current?.label}`}
          data-picked={current && current !== items[0] ? '' : undefined}
          disabled={disabled}
        >
          {Icon ? <Icon size={16} aria-hidden="true" /> : null}
          <span className={styles.triggerLabel}>{current?.label}</span>
          <ChevronDown size={16} aria-hidden="true" />
        </button>
      )}
      items={items.map((item) => ({
        key: item.value || 'all',
        label: item.label,
        icon: item.value === current?.value ? Check : undefined,
        selected: item.value === current?.value,
        onSelect: () => onChange(item.value),
      }))}
    />
  )
}
